import React from 'react';
import './emphasizedParagraph.scss';

const EmphasizedParagraph = () => {
  return (
    <div className="emphasizedPg">
      <div className="emphasizedPg__line" />
      <div className="emphasizedPg__text">
        <p>
          Global enterprises, government organizations, and startups all trust AWS to run their most
          important applications. AWS and Intel have been pioneering cloud technology and
          collaborating for customer innovation for over 16 years. Whether you’re looking to improve
          cost efficiency and performance for enterprise workloads, want to maximize the value of
          your data using performance-optimized AI or HPC capabilities, or need a cloud that enables
          game-changing IoT possibilities at the edge—AWS and Intel offer proven, workload-optimized
          cloud infrastructure to power the needs of virtually every application.
        </p>
      </div>
    </div>
  );
};

export default EmphasizedParagraph;
